let BACKEND_BASE_URL = (process.env.NODE_ENV === 'production') ? '/backend' : 'http://localhost:8081/backend'
let BACKEND_CONFIG_URL = (process.env.NODE_ENV === 'production') ? '/api/config/{{call_sid}}' : 'http://localhost:8081/api/config/{{call_sid}}'
let PG_BASE_URL = (process.env.NODE_ENV === 'production') ? '/pg' : 'http://localhost:8081/pg'

export default {
    API_BASE_URL: BACKEND_BASE_URL,
    BACKEND_CONFIG_URL: BACKEND_CONFIG_URL,
    PG_BASE_URL: PG_BASE_URL,
}